import { InputIcon, InputOptions, NullableTextInput } from '@tempots/beatui'

export function LooseEmailInput(options: InputOptions<string | null>) {
  return NullableTextInput({
    before: InputIcon({ icon: 'line-md:email-opened-alt-twotone' }),
    placeholder: 'you@example.com',
    ...options,
  })
}
